var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      value: _vm.chosenStatuses,
      options: _vm.options,
      multiple: _vm.multiple,
      customMultiStyleParent: _vm.getCustom,
      withoutLoading: "",
      placeholder: _vm.placeholder,
    },
    on: { input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }